import { DEFAULT_PATHS } from 'routes/paths';

export const APPS_TAB_PATHS = {
  marketplace: DEFAULT_PATHS.MARKETPLACE,
  installed: `${DEFAULT_PATHS.MARKETPLACE}/installed`,
  develop: `${DEFAULT_PATHS.MARKETPLACE}/develop`,
};

// The tabs' 20px top margin plus the 72px SubNavigation, so table layouts
// below them only switch to their scrolled header once the tabs are gone
export const APPS_TABS_HEIGHT = 92;
